const formatIsoDate = (date)=>{
    return date.toISOString().split("T")[0];
};
const getMostRecentInvoicePeriodEnd = (invoices)=>{
    if (!invoices.length) {
        return null;
    }
    return invoices.reduce((latest, invoice)=>{
        if (!latest) {
            return invoice.periodEnd;
        }
        return new Date(invoice.periodEnd).getTime() > new Date(latest).getTime() ? invoice.periodEnd : latest;
    }, null);
};
export const getConsumptionDateRange = (invoices = [], historicalEndDate, contractStartDate)=>{
    const lastInvoiceEndDate = getMostRecentInvoicePeriodEnd(invoices);
    const endDate = historicalEndDate ?? formatIsoDate(new Date());
    let startDate;
    if (lastInvoiceEndDate) {
        const nextDay = new Date(lastInvoiceEndDate);
        nextDay.setDate(nextDay.getDate() + 1);
        startDate = formatIsoDate(nextDay);
    } else {
        const thirtyDaysAgo = new Date(`${endDate}T00:00:00Z`);
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        startDate = formatIsoDate(thirtyDaysAgo);
    }
    if (contractStartDate && startDate < contractStartDate.slice(0, 10)) {
        startDate = contractStartDate.slice(0, 10);
    }
    if (startDate > endDate) {
        startDate = endDate;
    }
    return {
        startDate,
        endDate
    };
};
